<template>
  <Modal v-model="IsOpenModal" :closable="false" :mask-closable="false" :width="40" :footer-hide="true"
    :title="operationType==1?'新增企业':'编辑企业'">
    <div class="formGroup">
      <Form ref="enterpriseInfo" :model="enterpriseInfo" :rules="ruleValidate">
        <FormItem>
          <Row>
            <Col span="11">
            <FormItem prop="dept_full_cname">
              <Input class="ys_input_border_bottom" v-model="enterpriseInfo.dept_full_cname" placeholder="请输入企业全称" />
            </FormItem>
            </Col>
            <Col span="1">&nbsp;
            </Col>
            <Col span="11">
            <FormItem prop="dept_cn_name">
              <Input class="ys_input_border_bottom" v-model="enterpriseInfo.dept_cn_name" placeholder="请输入企业简称" />
            </FormItem>
            </Col>
          </Row>
        </FormItem>
        <FormItem>
          <Row>
            <Col span="11">
            <FormItem prop="dept_code">
              <Input class="ys_input_border_bottom" v-model="enterpriseInfo.dept_code" placeholder="请输入企业代码" />
            </FormItem>
            </Col>
            <Col span="1">&nbsp;
            </Col>
            <Col span="11">
            <FormItem prop="dept_type">
              <Select v-model="enterpriseInfo.dept_type" placeholder="请选择企业类型">
                <Option v-for="(item,index) in EnterpriseTypeData" :key="index" :value="parseInt(item.con_code)">
                  {{item.con_value}}
                </Option>
              </Select>
            </FormItem>
            </Col>
          </Row>
        </FormItem>
        <FormItem>
          <Row>
            <Col span="11">
            <FormItem prop="dept_address">
              <Input class="ys_input_border_bottom" v-model="enterpriseInfo.dept_address" placeholder="请输入企业地址" />
            </FormItem>
            </Col>
            <Col span="1">&nbsp;
            </Col>
            <Col span="11">
            <FormItem prop="dept_post_code">
              <Input class="ys_input_border_bottom" v-model="enterpriseInfo.dept_post_code" placeholder="请输入邮编号" />
            </FormItem>
            </Col>
          </Row>
        </FormItem>
        <FormItem>
          <Row>
            <Col span="11">
            <FormItem prop="dept_email">
              <Input class="ys_input_border_bottom" v-model="enterpriseInfo.dept_email" placeholder="请输入企业邮箱" />
            </FormItem>
            </Col>
            <Col span="1">&nbsp;
            </Col>
            <Col span="11">
            <FormItem prop="dept_contcat">
              <Input class="ys_input_border_bottom" v-model="enterpriseInfo.dept_contcat" placeholder="请输入联系方式" />
            </FormItem>
            </Col>
          </Row>
        </FormItem>
      </Form>
    </div>
    <!-- 按钮组 -->
    <div class="btnGroup">
      <Button class="ys-cancel" @click="handleClick(1)">取消</Button>&nbsp;&nbsp;
      <Button class="ys-confirm" @click="handleClick(2)">{{operationType==1?'保存':'修改'}}</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: "AddEnterprise",
    props: {
      // 是否打开弹框
      IsOpenModal: {
        type: Boolean,
        default: false
      },
      // 操作状态 1 新增  2 编辑
      operationType: {
        type: Number,
        default: 1
      },
      // 编辑所需的企业详细数据信息
      EditEnterpriseInfo: {
        type: Object,
        default: () => ({})
      },
      // 企业类型数据
      EnterpriseTypeData: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        enterpriseInfo: {
          dept_full_cname: '', // 企业名称
          dept_cn_name: "", //简称
          dept_type: "", //企业类型 
          dept_level: "0", //部门级别
          dept_address: "", //地址
          dept_contcat: "", //联系方式
          dept_post_code: "", //邮编
          dept_email: "", //邮箱
          dept_code: "", //企业代码
        },
        ruleValidate: {
          dept_full_cname: [{
            required: true,
            message: '请输入企业名称',
            trigger: 'blur'
          }],
          dept_cn_name: [{
            required: true,
            message: '请输入企业简称',
            trigger: 'blur'
          }],
          dept_address: [{
            required: true,
            message: '请输入企业地址',
            trigger: 'blur'
          }],
          dept_contcat: [{
            required: true,
            message: '请输入企业联系方式',
            trigger: 'blur'
          }],
          dept_post_code: [{
              required: true,
              message: '请输入邮编号',
              trigger: 'blur'
            },
            {
              message: '请输入正确的邮编号',
              trigger: 'blur'
            }
          ],
          dept_code: [{
            required: true,
            message: '请输入企业代码',
            trigger: 'blur'
          }],
          dept_email: [{
              required: true,
              message: '请输入企业邮箱',
              trigger: 'blur'
            },
            {
              message: '请输入正确的邮箱地址',
              trigger: 'blur'
            }
          ],
          dept_contcat: [{
              required: true,
              message: '请输入企业联系方式',
              trigger: 'blur'
            },
            {
              pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{7,8}$/,
              message: '请输入正确的手机号或座机号',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    mounted() {
      // 表单重置
      this.$refs['enterpriseInfo'].resetFields();
    },
    methods: {
      handleClick(index) {
        // 1 取消   2 保存
        if (index === 1) {
          this.$emit("on-handleClick", index);
        } else {
          this.$refs['enterpriseInfo'].validate((valid) => {
            if (valid) {
              this.$emit("on-handleClick", index, this.enterpriseInfo);
            } else {
              this.$Message.error('请完善企业信息!');
            }
          })
        }
      }
    },
    watch: {
      IsOpenModal(newInfo) {
        // 表单重置
        newInfo ? this.$refs['enterpriseInfo'].resetFields() : ""
      },
      EditEnterpriseInfo(newValue) {
        if (this.operationType == 2) {
          this.enterpriseInfo = newValue;
        }
      },
      operationType(newVal) {
        if (newVal === 1) {
          this.enterpriseInfo = {
            dept_full_cname: '', // 企业名称
            dept_cn_name: "", //简称
            dept_type: "", //企业类型 
            dept_level: "0", //部门级别
            dept_address: "", //地址
            dept_contcat: "", //联系方式
            dept_post_code: "", //邮编
            dept_email: "", //邮箱
            dept_code: "", //企业代码
          }
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .formGroup {
    padding: 0 0 15px 0;
  }

  .btnGroup {
    height: 50px;
    width: 100%;
    padding-right: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
</style>